import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Factory } from "lucide-react";
import { useMaterialCheck } from "@/hooks/useMaterialCheck";
import { ShortageTable } from "@/components/planning/ShortageTable";
import { ShortageWarning } from "@/components/planning/ShortageWarning";

// Shown before creating a production order: explodes the product's BOM, compares required
// raw materials against stock, highlights shortages in red, and lets you raise POs inline.
export default function MaterialShortageDialog({ product, facility, onClose, onProceed, onCreatePO, onBulkPO }) {
  const mc = useMaterialCheck({ product, facility, onCreatePO, onBulkPO });

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="material-shortage-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Material check — {product.name}</DialogTitle>
          <DialogDescription className="text-xs">Raw Materials required to produce {Number(product.quantity).toLocaleString("en-IN")} units. Shortages are highlighted in red.</DialogDescription>
        </DialogHeader>

        <ShortageTable loading={mc.loading} materials={mc.materials} ordered={mc.ordered} onRaisePO={mc.raisePO} />

        {!mc.loading && mc.shortages.length > 0 && (
          <ShortageWarning count={mc.shortages.length} allOrdered={mc.allOrdered} onOrderAll={onBulkPO ? mc.orderAllMissing : undefined} />
        )}

        <DialogFooter className="mt-3">
          <Button variant="outline" onClick={onClose}>Close</Button>
          <Button className="bg-blue-600 hover:bg-blue-700" onClick={onProceed} data-testid="shortage-proceed"><Factory className="h-4 w-4 mr-1" />Create Production Order</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
